import * as React from 'react';
import Top from "../Top";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import {styled} from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import {FormContainer, TextFieldElement} from "react-hook-form-mui";
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import * as util from "../../utils/util";
import api from "../../utils/api";
import { notifyApiError } from "../../utils/apiError";

const typeFindParam = { id: '', name: '', phone: '' };

const FindPassword = () => {
  const [findParam, setFindParam] = React.useState(typeFindParam);

  // 비밀번호 초기화
  async function handleFindPassword(data :any){
    findParam.id = data.id;
    findParam.name = data.name;
    findParam.phone = data.phone;
    await api.post('auth/findUserPassword', findParam).then((res:any) => {
      alert(res.data.message);
    }).catch(function (error:any) {
      notifyApiError(error, '비밀번호를 초기화하지 못했습니다.');
    });
  }
  

  
  return (

    <Container sx={Logbg}>
      <Top title="비밀번호 찾기" />

      <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>
        <FormContainer
          values={{id: findParam.id, name: findParam.name, phone: findParam.phone}}
          onSuccess={data => handleFindPassword(data)}
        >

          <Card sx={{ p: '20px 20px 30px 20px', bgcolor:'#fff' }}>
            <Divider sx={{fontSize:18, mb:2, fontWeight:700}}>비밀번호 찾기</Divider>

            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <AccountCircleIcon sx={profileIcon} />
              <TextFieldElement
                name="id"
                id="input-id" label="아이디" variant="standard"
                fullWidth
                rules={{
                  required: '필수 입력입니다.',
                }}
                onChange={(e :any) => {
                  setFindParam((prev) => true ? {...prev, id: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
           
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <AssignmentIndIcon sx={profileIcon} />
              <TextFieldElement
                name="name"
                id="input-name" label="이름" variant="standard"
                fullWidth
                rules={{
                  required: '필수 입력입니다.',
                }}
                onChange={(e :any) => {
                  setFindParam((prev) => true ? {...prev, name: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2}}>
              <PhoneAndroidIcon sx={profileIcon} />
              <TextFieldElement
                name="phone"
                id="input-tel" label="휴대전화" variant="standard"
                fullWidth
                placeholder="XXX-XXXX-XXXX"
                rules={{
                  required: '필수 입력입니다.',
                  pattern: {
                    value: /^[0-9]{3}[-]+[0-9]{4}[-]+[0-9]{4}$/i,
                    message: '연락처 형식을 확인해주세요.',
                  },
                }}
                onChange={(e :any) => {
                  setFindParam((prev) => true ? {...prev, phone: util.formatPhoneNumber(e.target.value)} : prev)
                }}
                inputProps={{ maxLength: 13 }}
                sx={loginField}
              />
            </Box>
            
          </Card>

          <Box sx={{ p: 0}}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3,  borderRadius: '20px' }}>
              <CareButton variant="contained" type={'submit'}>
                비밀번호 찾기
              </CareButton>
            </Stack>
          </Box>
        </FormContainer>

      </Stack>

    </Container>

  );
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});
const loginField = {
  '& input': {
    fontSize: 16
  },

  '& label': {
    color: '#888',
    fontSize: 16
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#f6f6f6',
  height: '100%',
  minHeight: '100vh',
  pb: 4,
  minWidth: '320px',
  pt: 10,
}

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '100%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

export default FindPassword;